import { Component, OnInit, ViewChild, NgZone, ChangeDetectorRef } from '@angular/core';
import { NgModel, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../../_services/user.service';
import { Subscription } from 'rxjs';
import { AgreementComponent } from '../../directive/agreement/agreement.component';
import { MatDialog } from '@angular/material';
import { PhoneAuthenticationService } from '../../_services/phone-authentication.service';
import { ScriptLoaderService } from '../../_services/script-loader.service';
import { ApiService } from '../../_services/api.service';
import { BadwordsService } from '../../_services/badwords.service';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-save-username',
  templateUrl: './save-username.component.html',
  styleUrls: ['./save-username.component.css']
})
export class SaveUsernameComponent implements OnInit {
  [x: string]: any;
  @ViewChild('username') public username: NgModel;
  @ViewChild('f') public form: NgForm;
  user: any;
  lastUser;
  registerModel: any = { day: 'Gün', month: 'Ay', year: 'Yıl' };
  loading: boolean;
  isCodeSent: boolean;
  isInvalidPhoneNumber: boolean;
  isInvalidCode: boolean;
  notSms = false;
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  days = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15',
    '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
  months = [
    { month: 'Ocak', value: '01' },
    { month: 'Şubat', value: '02' },
    { month: 'Mart', value: '03' },
    { month: 'Nisan', value: '04' },
    { month: 'Mayıs', value: '05' },
    { month: 'Haziran', value: '06' },
    { month: 'Temmuz', value: '07' },
    { month: 'Ağustos', value: '08' },
    { month: 'Eylül', value: '09' },
    { month: 'Ekim', value: '10' },
    { month: 'Kasım', value: '11' },
    { month: 'Aralık', value: '12' }];
  years = [];
  blacklist = false;
  private subscription: Subscription = new Subscription();
  constructor(
    private zone: NgZone,
    private cd: ChangeDetectorRef,
    private scriptLoader: ScriptLoaderService,
    public dialog: MatDialog,
    private httpclient: HttpClient,
    private afs: AngularFirestore,
    private userService: UserService,
    private router: Router,
    private apiService: ApiService,
    private badwordsService: BadwordsService,
    private phoneAuthService: PhoneAuthenticationService) {
    let dateNow = new Date();
    let currentYear = dateNow.getFullYear();
    for (let i = currentYear - 100; i < currentYear; i++) {
      this.years.push(i);
    }
  }

  ngOnInit() {
    this.subscription.add(this.afs.collection('users').doc(localStorage.getItem('currentUserId')).valueChanges().subscribe(user => {
      this.user = user;
      this.cd.markForCheck();
    }))

  }
  usernameInputKeyPress(event: KeyboardEvent) {
    if (event.keyCode == 32) {
      event.preventDefault();
      return;
    }
    return (event.charCode >= 65 && event.charCode <= 90) ||
      (event.charCode >= 97 && event.charCode <= 122) ||
      (event.charCode >= 48 && event.charCode <= 57) ||
      event.charCode == 95;
  }
  isElderlyFunc() {
    let time = new Date(this.registerModel.year + "-" + this.registerModel.month + "-" + this.registerModel.day);
    let age = Date.now() - Number(time);
    let ageGet = Math.floor(age / 1000 / 60 / 60 / 24 / 365.25);
    return ageGet < 18;

  }
  usernameInputKeyUp() {
    this.checkUsername(isExist => {
      if (isExist) this.username.control.setErrors({ 'valid': false });
      this.cd.markForCheck()
    });
  }
  checkUsername(callback: (data: boolean) => void) {

    this.afs.collection('entities').ref.where('uniqueName', '==', this.registerModel.username.toLowerCase()).get().then(snap => {

      if (snap) {
        callback(!snap.empty)
      }

    })

  }
  checkBadWord() {

    this.subscription = this.badwordsService.getBadwords().subscribe(badwords => {
      this.blacklist = false;
      badwords.forEach(badword => {
        if (this.registerModel.username == badword) {
          this.username.control.setErrors({ 'valid': false });
          this.blacklist = true;
        }
      })
      if (this.blacklist == false) {

        this.save()
      }
    })
  }
  async save() {

    if (this.blacklist == false)
      this.loading = true;
    if (!this.isCodeSent) {
      this.phoneAuthService.sendOtp(this.registerModel.phoneNumber)
        .then(res => {
          this.loading = false;
          this.isCodeSent = true;
          this.isInvalidPhoneNumber = false;
        }).catch(err => {
          this.isInvalidPhoneNumber = true;
          this.loading = false;
        });
      return;
    }
    if (!this.phoneAuthService.confirm(this.registerModel.code)) {
      this.isInvalidCode = true;
      this.loading = false;
      return;
    }

    this.isInvalidPhoneNumber = false;
    this.checkUsername(isExist => {

      if (!isExist) {

        let update = {};

        this.afs.collection('entities').ref.where('uniqueName', '==', this.user.username).get().then(snap => {
          snap.docs.map(snap1 => {
            let updatedUser = snap1.data();

            updatedUser.phoneNumber = this.registerModel.phoneNumber;
            updatedUser.username = this.registerModel.username.replace(/\s/g, "").toLowerCase();
            updatedUser.searchTerm = (this.registerModel.username + this.user.firstname + this.user.lastname).toLowerCase();
            updatedUser.uniqueName = updatedUser.username
            const id = localStorage.getItem("currentUserId");
            this.afs.collection('entities').doc(snap1.id).update(updatedUser).then(() => {
              this.afs.collection('users').doc(id).update({
                phoneNumber: this.registerModel.phoneNumber,
                username: updatedUser.username,
                birthday: { day: this.registerModel.day, month: this.registerModel.month, year: this.registerModel.year },
                isNewRegistered: false
              })
            })
              .then(() => this.scriptLoader.load('body', 'assets/js/adwords-analytics.js'))
              .then(() => {
                this.subscription = this.userService.getUser().subscribe(elem => {
                  this.lastUser = elem;

                })


                var users = {
                  userKey: id,
                  agreement: this.lastUser.agreement || null,
                  birthday: { day: this.registerModel.day, month: this.registerModel.month, year: this.registerModel.year },
                  totalPoint: this.lastUser.point.totalPoint || null,
                  username: updatedUser.username,
                  email: this.lastUser.email,
                  firstname: this.lastUser.firstname,
                  isEmailVerified: this.lastUser.isEmailVerified || null,
                  isSecret: this.lastUser.isSecret || null,
                  joinDate: this.dateFormat(new Date(this.lastUser.joinDate)),
                  lastname: this.lastUser.lastname,
                  level: this.lastUser.level,
                  city: this.lastUser.city || null,
                  phoneNumber: this.registerModel.phoneNumber || null,
                  education: this.lastUser.education || null,
                  gender: this.lastUser.gender || null,
                  job: this.lastUser.job || null,
                  profileImage: this.lastUser.profileImage || null,
                  following: this.lastUser.following ? this.lastUser.following.length : 0,
                  followers: this.lastUser.followers ? this.lastUser.followers.length : 0
                }
                const option = {
                  data: {
                    customToken: id,
                    email: this.lastUser.email,
                    firstname: updatedUser.username,
                    name: this.lastUser.firstname
                  }
                }

                this.request(option);

                this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(() => {
                  this.router.navigate(['/home']).then(() => {
                    let welcomePost: any = {
                      text: "Hoşgeldin " + this.lastUser.firstname + " " + this.lastUser.lastname + "😃",
                      modifyDate: this.lastUser.modifyDate,
                      settings: {
                        isOnlyFriend: false,
                        isNameSecret: false,
                        isGlobal: true,
                        isAllowComments: false
                      },
                      author: {
                        firstname: "bigadvice",
                        lastname: "",
                        username: "bigadvice",
                        profileImage: "UserIcon.png"
                      },
                      valueOf: 0,
                      order: -1 * this.lastUser.modifyDate,
                      username: updatedUser.username
                    };
                    this.afs.collection('welcomePosts').doc(id).set(welcomePost);
                  })
                }

                );

              });
          });
        });

      } else {

        this.username.control.setErrors({ 'valid': false });
        this.loading = false;
      }
    });
  }

  request(option) {
    const sub = this.httpclient.post('https://api.bigadvice.com/email/sendWelcomenew', option.data)
      .subscribe((res) => {
        if (res === "OK") {
          sub.unsubscribe();
        }
      });
  }
  openAgreement(type) {
    this.dialog.open(AgreementComponent, {
      width: '50%',
      height: '82%',
      data: {
        type: type
      }
    });
  }
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }
  notSend() {
    this.notSms = true;
    this.isCodeSent = false;

  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/save-username/save-username.component.ts